import { SelectChangeEvent } from "src/components/MuiGenerals";
import { useBatchContractSweepFormContext } from "../../../contexts";
import ChainNameSelection from "src/components/ContractSweep/ChainNameSingleSelection";

function ChainNameSingleSelection() {
  const {
    translate: t,
    fields,
    setFields,
  } = useBatchContractSweepFormContext();
  const label = t("chain_name");

  const onChange = (e: SelectChangeEvent<string>) => {
    setFields((prev) => ({
      ...prev,
      chainName: e.target.value,
      currency: "",
      spenderAddress: "",
      isSmartAccount: false,
      isFreeBandwidthOnly: false,
      maxNumberOfAddresses: "1000",
    }));
  };

  return (
    <>
      <div>{label}</div>
      <ChainNameSelection
        value={fields.chainName}
        fieldName={label}
        onChange={onChange}
      />
    </>
  );
}

export default ChainNameSingleSelection;
